module.exports = __webpack_public_path__ + "static/media/article.4d39d7b2.jpg";